import { CheckSquare, Wrench, Car, Package, MessageSquareWarning, HelpCircle } from 'lucide-react';

/** Druhy úkolů a hlášení — ikona, název, komu hlášení jde. */
export const DRUHY_UKOLU = {
    ukol:      { nazev: 'Úkol',       Icon: CheckSquare,          komu: 'konkrétnímu člověku' },
    zavada:    { nazev: 'Závada',     Icon: Wrench,               komu: 'Údržba — stroje, vybavení, budova' },
    vozidlo:   { nazev: 'Vozidlo',    Icon: Car,                  komu: 'Flotila — závada nebo nehoda auta' },
    surovina:  { nazev: 'Surovina',   Icon: Package,              komu: 'Suroviny a vedoucí směn — co chybí, co se kazí' },
    reklamace: { nazev: 'Reklamace',  Icon: MessageSquareWarning, komu: 'Objednávky — stížnost zákazníka' },
    jine:      { nazev: 'Jiné',       Icon: HelpCircle,           komu: 'nadřízený' },
};

export const STAVY_UKOLU = {
    otevreno: 'Otevřené',
    resi_se: 'Řeší se',
    hotovo: 'Hotovo',
    zamitnuto: 'Zamítnuto',
};

/** „dnes 18:00", „zítra", „12. 10." */
export function formatTermin(iso) {
    if (!iso) return '';
    const d = new Date(iso);
    const dnes = new Date(); dnes.setHours(0, 0, 0, 0);
    const den = new Date(d); den.setHours(0, 0, 0, 0);
    const rozdil = Math.round((den - dnes) / 86400000);
    const cas = d.getHours() || d.getMinutes() ? ` ${d.toLocaleTimeString('cs', { hour: '2-digit', minute: '2-digit' })}` : '';
    if (rozdil === 0) return `dnes${cas}`;
    if (rozdil === 1) return `zítra${cas}`;
    if (rozdil === -1) return `včera${cas}`;
    return `${d.getDate()}. ${d.getMonth() + 1}.${cas}`;
}

export const poTerminu = (u) => u.termin && ['otevreno', 'resi_se'].includes(u.stav) && new Date(u.termin) < new Date();
